import { FAKE_SELECTS_SELECTOR } from '@Support/selectors';

export default {
    '[data-tippy-content], [data-tippy-html], .js-has-tippy': {
        modules: 'tippy'
    },
    '.js-toggle': {
        modules: 'toggle-function'
    },
    '.js-articles-tiles-hook': {
        modules: 'hover-toggle',
        config: () => {
            return {
                target: function($trigger) {
                    return $trigger.find('.js-articles-tiles-short-contents');
                },
                linkWrapperSelector: '.js-link-wrapper'
            }
        }
    },
    '.js-link-wrapper': {
        modules: 'link-wrapper'
    },
    '.js-variant': {
        modules: 'variant'
    },
    '.editable, .js-editable': {
        modules: 'editable'
    },
    [FAKE_SELECTS_SELECTOR]: {
        modules: 'fake-select'
    },
    '.ci-scroller': {
        modules: 'scroller'
    },
    '.js-ic-ce': {
        modules: 'icube-editor'
    }
}